import { Box, Checkbox, FormControlLabel, TextField } from '@mui/material';
import { OneMedia, SimpleSelect, isImage } from '@prismamedia/one-components';
import { Dispatch, FC, SetStateAction } from 'react';

export const MediaFields: FC<{
  media: OneMedia;
  setMedia: Dispatch<SetStateAction<OneMedia>>;
  formats?: { label: string; value: string }[];
}> = ({ media, setMedia, formats }) => {
  if (!media) return null;

  return (
    <>
      {isImage(media) && (
        <Box sx={{ display: 'flex', mb: 3 }}>
          <TextField
            sx={{ flex: 1 }}
            data-testid="multimedia-link"
            label="Lien"
            name="imageLink"
            onChange={({ target }) =>
              setMedia((prev) => ({ ...prev, href: target.value }))
            }
            value={media.href || ''}
            variant="standard"
          />
          <FormControlLabel
            sx={{ ml: 2 }}
            control={
              <Checkbox
                checked={Boolean(media.target)}
                color="primary"
                disabled={!media.href}
                name="target"
                onChange={(_, value) => {
                  setMedia((prev) => ({
                    ...prev,
                    rel: value ? 'nofollow' : null,
                    target: value ? '_blank' : null,
                  }));
                }}
              />
            }
            label="Nouvel onglet"
          />
        </Box>
      )}
      <TextField
        label="Légende"
        sx={{ mb: 3 }}
        variant="standard"
        value={media.caption || ''}
        onChange={({ target }) =>
          setMedia((prev) => ({ ...prev, caption: target.value }))
        }
      />
      {formats && (
        <SimpleSelect
          label="Format"
          value={media.format || ''}
          options={formats}
          variant="standard"
          onChange={(_, value) =>
            setMedia((prev) => ({ ...prev, format: value }))
          }
        />
      )}
    </>
  );
};
